import AssignmentOutlined from '@mui/icons-material/AssignmentOutlined';
import BuildOutlined from '@mui/icons-material/BuildOutlined';
import HandymanOutlined from '@mui/icons-material/HandymanOutlined';
import LocalShippingOutlined from '@mui/icons-material/LocalShippingOutlined';
import NearMeOutlined from '@mui/icons-material/NearMeOutlined';
import PanToolOutlined from '@mui/icons-material/PanToolOutlined';
import { SvgIconProps } from '@mui/material';

import {
  HomeIcon,
  SearchIcon,
  PlusIcon,
  DownloadIcon,
  SwapIcon,
  EditIcon,
  UploadIcon,
  CalendarIcon,
  FileIcon,
  UserIcon,
  SettingsIcon,
} from '../../../atoms/NavIcons';

type IconComponent = (props: SvgIconProps) => React.JSX.Element;

const sectionIconMap: Record<string, IconComponent> = {
  Home: HomeIcon,
  'Pick Tasks': PanToolOutlined as unknown as IconComponent,
  Search: SearchIcon,
  Create: PlusIcon,
  Import: DownloadIcon,
  Movements: SwapIcon,
  'Bulk Update': EditIcon,
  Receive: DownloadIcon,
  Dispatch: UploadIcon,
  Attendance: CalendarIcon,
  'My Reports': FileIcon,
  Users: UserIcon,
  Settings: SettingsIcon,
  Jobs: AssignmentOutlined as unknown as IconComponent,
  Structure: NearMeOutlined as unknown as IconComponent,
  Parts: BuildOutlined as unknown as IconComponent,
  Shipments: LocalShippingOutlined as unknown as IconComponent,
  Reports: FileIcon,
  Configure: SettingsIcon,
  Tools: HandymanOutlined as unknown as IconComponent,
};

export const getIconForSection = (name: string): IconComponent => sectionIconMap[name] ?? HomeIcon;
